import React, {Component} from 'react';
import {NavLink, Link, withRouter} from 'react-router-dom';
import {injectIntl} from 'react-intl';
import Util from '../../../forecast-app/shared/util/util';
import NestedDropdown from '../../../forecast-app/shared/components/dropdowns/nested_dropdown';
import ActionsMenu from '../../../forecast-app/shared/components/action-menu/actions_menu';
import constants, {ESTIMATION_UNIT, PROJECT_STATUS} from '../../../constants';
import * as tracking from '../../../tracking';
import {hasFeatureFlag} from '../../../forecast-app/shared/util/FeatureUtil';
import {hasSomePermission, hasPermission, isClientUser} from '../../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../Permissions';

const actionMenuOptionTranslationIds = new Map([
	['files', 'common.files'],
	['client', 'common.client'],
	['rates', 'settings.rate-card'],
	['invoicing', 'common.invoicing'],
	['settings', 'settings.title'],
	['xero', 'Xero'],
	['economic', 'e-conomic'],
	['connected-projects', 'connected_projects.title'],
	['group-settings', 'settings.title'],
]);

class ProjectSectionHeader extends Component {
	componentDidUpdate(prevProps) {
		let prevPathEnding;
		if (this.props.project) {
			prevPathEnding = localStorage.getItem('project-section-last-viewed');
		} else {
			prevPathEnding = localStorage.getItem('project-group-section-last-viewed');
		}
		const thisPathEnding = this.props.history.location.pathname.split('/').pop();
		if (thisPathEnding !== prevPathEnding) {
			if (this.props.project) {
				Util.localStorageSetItem('project-section-last-viewed', thisPathEnding);
			} else {
				Util.localStorageSetItem('project-group-section-last-viewed', thisPathEnding);
			}
		}
	}
	onProjectChange(selected) {
		let pathname;
		if (selected.isProjectGroup) {
			pathname = '/connected/X-' + selected.companyProjectGroupId + '/';
			let lastViewedPage = localStorage.getItem('project-group-section-last-viewed') || 'workflow';
			pathname += lastViewedPage;
		} else {
			pathname = '/project/P-' + selected.companyProjectId + '/';
			let lastViewedPage = localStorage.getItem('project-section-last-viewed') || 'workflow';
			if (
				(lastViewedPage === 'sprints' && !selected.sprintTimeBox) ||
				(lastViewedPage === 'economic' && !selected.economicProject)
			) {
				lastViewedPage = 'workflow';
			}
			pathname += lastViewedPage;
		}

		tracking.trackElementClicked('Change project dropdown header');

		this.props.history.push(pathname);
	}
	getActiveIndicator() {
		return (
			<div className="active-indicator">
				<div className="border" />
			</div>
		);
	}
	navigateToProjectSectionFromActionMenu(section) {
		const navLinkBase = this.props.project
			? constants.projectUrl(this.props.project.companyProjectId)
			: constants.projectGroupUrl(this.props.projectGroup.companyProjectGroupId);
		this.props.history.push(`${navLinkBase}/${section}`);
	}

	showCurrentLocationForActionMenuOptions(textColor) {
		const currentLocation = window.location.pathname;
		const lastSlashIndex = currentLocation.lastIndexOf('/');
		const path =
			currentLocation.length >= lastSlashIndex + 1
				? currentLocation.substring(lastSlashIndex + 1, currentLocation.length)
				: '';
		const navLinkBase = this.props.project
			? constants.projectUrl(this.props.project.companyProjectId)
			: constants.projectGroupUrl(this.props.projectGroup.companyProjectGroupId);
		if (path !== '' && actionMenuOptionTranslationIds.has(path) && !isClientUser()) {
			const translationId = actionMenuOptionTranslationIds.get(path);
			return (
				<li>
					<NavLink
						to={`${navLinkBase}/${path}`}
						className={path}
						activeClassName={'active'}
						style={{color: textColor}}
					>
						{path === 'xero' || path === 'economic' ? (
							<span title={translationId}>{translationId}</span>
						) : (
							<span title={this.props.intl.formatMessage({id: translationId})}>
								{this.props.intl.formatMessage({id: translationId})}
							</span>
						)}
						{this.getActiveIndicator()}
					</NavLink>
				</li>
			);
		}

		return null;
	}

	getLinkTo(id) {
		const curLocation = window.location.href;
		const locArr = curLocation.split('/');
		let locPage = locArr[locArr.length - 1];
		return `/connected/X-${id}/${locPage}`;
	}

	getProjectOptions(projects_dropdown_options) {
		const {formatMessage} = this.props.intl;
		const running_projects = [],
			planning_projects = [],
			halted_projects = [],
			opportunity_projects = [];

		const hasOpportunityAccess = Util.hasOpportunityAccess(this.props.viewer.company.modules);

		this.props.projects.edges
			.filter(
				project =>
					(this.props.viewer.client || !project.node.isInProjectGroup) && project.node.status !== PROJECT_STATUS.DONE
			)
			.forEach(project => {
				const el = {
					projectColor: project.node.projectColor,
					label: project.node.name || formatMessage({id: 'common.untitled'}),
					name: project.node.name || formatMessage({id: 'common.untitled'}),
					searchString:
						'P' + project.node.companyProjectId + (project.node.name || formatMessage({id: 'common.untitled'})),
					companyProjectId: project.node.companyProjectId,
					sprintTimeBox: project.node.sprintTimeBox,
					economicProject: project.node.economicProject,
					sortValue: project.node.companyProjectId,
					isHalted: project.node.status === PROJECT_STATUS.HALTED,
				};
				if (project.node.status === PROJECT_STATUS.OPPORTUNITY && hasOpportunityAccess) {
					opportunity_projects.push(el);
				} else if (
					project.node.status === PROJECT_STATUS.PLANNING ||
					(project.node.status === PROJECT_STATUS.OPPORTUNITY && !hasOpportunityAccess)
				) {
					planning_projects.push(el);
				} else if (project.node.status === PROJECT_STATUS.RUNNING) {
					running_projects.push(el);
				} else if (project.node.status === PROJECT_STATUS.HALTED) {
					halted_projects.push(el);
				}
			});
		this.props.projectGroups.edges
			.filter(
				projectGroup =>
					projectGroup.node.projects &&
					projectGroup.node.projects.edges.filter(project => project.node.status !== PROJECT_STATUS.DONE).length !== 0
			)
			.forEach(projectGroup => {
				const groupEl = {
					color: projectGroup.node.color,
					label: projectGroup.node.name || formatMessage({id: 'common.untitled'}),
					name: projectGroup.node.name || formatMessage({id: 'common.untitled'}),
					searchString:
						'X' +
						projectGroup.node.companyProjectGroupId +
						(projectGroup.node.name || formatMessage({id: 'common.untitled'})),
					companyProjectGroupId: projectGroup.node.companyProjectGroupId,
					isProjectGroup: true,
					sortValue: projectGroup.node.companyProjectGroupId + '_group',
					excludeFromCount: true,
				};
				let groupElAddedToRunning = false,
					groupElAddedToPlanning = false,
					groupElAddedToOpportunity = false,
					groupElAddedToHalted = false;
				projectGroup.node.projects.edges.forEach(project => {
					const projectObject = {
						projectColor: project.node.projectColor,
						label: project.node.name || formatMessage({id: 'common.untitled'}),
						name: project.node.name || formatMessage({id: 'common.untitled'}),
						searchString:
							'P' + project.node.companyProjectId + (project.node.name || formatMessage({id: 'common.untitled'})),
						companyProjectId: project.node.companyProjectId,
						sprintTimeBox: project.node.sprintTimeBox,
						economicProject: project.node.economicProject,
						isInProjectGroup: true,
						sortValue: projectGroup.node.companyProjectGroupId + '_group',
						isHalted: project.node.status === PROJECT_STATUS.HALTED,
						isDone: project.node.status === PROJECT_STATUS.DONE,
					};
					if (
						project.node.status === PROJECT_STATUS.PLANNING ||
						(project.node.status === PROJECT_STATUS.OPPORTUNITY && !hasOpportunityAccess)
					) {
						if (!groupElAddedToPlanning) {
							planning_projects.push(groupEl);
							groupElAddedToPlanning = true;
						}
						planning_projects.push(projectObject);
					} else if (project.node.status === PROJECT_STATUS.RUNNING) {
						if (!groupElAddedToRunning) {
							running_projects.push(groupEl);
							groupElAddedToRunning = true;
						}
						running_projects.push(projectObject);
					} else if (project.node.status === PROJECT_STATUS.OPPORTUNITY && hasOpportunityAccess) {
						if (!groupElAddedToOpportunity) {
							opportunity_projects.push(groupEl);
							groupElAddedToOpportunity = true;
						}
						opportunity_projects.push(projectObject);
					} else if (project.node.status === PROJECT_STATUS.HALTED) {
						if (!groupElAddedToHalted) {
							halted_projects.push(groupEl);
							groupElAddedToHalted = true;
						}
						halted_projects.push(projectObject);
					}
				});
			});
		const sortProjects = (a, b) => {
			if (a.sortValue < b.sortValue) return -1;
			if (a.sortValue > b.sortValue) return 1;
			if (a.sortValue === b.sortValue) {
				if (a.isInProjectGroup && !b.isInProjectGroup) {
					return 1;
				}
			}
			return 0;
		};
		running_projects.sort(sortProjects);
		planning_projects.sort(sortProjects);
		halted_projects.sort(sortProjects);
		opportunity_projects.sort(sortProjects);

		projects_dropdown_options.push(
			{value: 'running_projects', label: formatMessage({id: 'project_status.running'}), nestedOptions: running_projects},
			{
				value: 'planning_projects',
				label: formatMessage({id: 'project_status.planning'}),
				nestedOptions: planning_projects,
			}
		);
		if (hasOpportunityAccess) {
			projects_dropdown_options.push({
				value: 'opportunity_projects',
				label: formatMessage({id: 'project_status.opportunity'}),
				nestedOptions: opportunity_projects,
			});
		}
		projects_dropdown_options.push({
			value: 'halted_projects',
			label: formatMessage({id: 'project_status.halted'}),
			nestedOptions: halted_projects,
		});
	}
	render() {
		if (!this.props.project && !this.props.projectGroup) return <div></div>;
		const projectOptions = [];
		this.getProjectOptions(projectOptions);
		const textColor = this.props.project
			? Util.getTextColorV2(this.props.project.projectColor)
			: this.props.projectGroup
			? Util.getTextColorV2(this.props.projectGroup.color)
			: '#ffffff';
		const useWhiteColor = textColor === '#ffffff';
		const {formatMessage} = this.props.intl;
		const canUpdateProjects = hasPermission(PERMISSION_TYPE.PROJECTS_UPDATE);
		const clientUser = isClientUser();
		const hasFinancialAccess = hasSomePermission([
			PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION,
			PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE,
		]);
		const isLinkedToEconomicProject = this.props.project && this.props.project.economicProject;
		const actionMenuOptions = [];
		if (!this.props.projectGroup && !clientUser && !this.props.viewer.company.hideFiles) {
			actionMenuOptions.unshift({
				text: formatMessage({id: actionMenuOptionTranslationIds.get('files')}),
				cy: 'files',
				onClick: this.navigateToProjectSectionFromActionMenu.bind(this, 'files'),
			});
		}
		if (!this.props.projectGroup && !clientUser) {
			actionMenuOptions.push({
				text: formatMessage({id: actionMenuOptionTranslationIds.get('client')}),
				cy: 'client',
				onClick: this.navigateToProjectSectionFromActionMenu.bind(this, 'client'),
			});
		}
		if (!this.props.projectGroup && canUpdateProjects && isLinkedToEconomicProject) {
			actionMenuOptions.push({
				text: 'e-conomic',
				onClick: this.navigateToProjectSectionFromActionMenu.bind(this, 'economic'),
			});
		}
		if (!this.props.projectGroup && canUpdateProjects) {
			actionMenuOptions.push({
				text: formatMessage({id: actionMenuOptionTranslationIds.get('settings')}),
				cy: 'settings',
				onClick: this.navigateToProjectSectionFromActionMenu.bind(this, 'settings'),
			});
		}
		if (this.props.projectGroup && canUpdateProjects) {
			actionMenuOptions.push({
				text: formatMessage({id: actionMenuOptionTranslationIds.get('connected-projects')}),
				cy: 'group-projects',
				onClick: this.navigateToProjectSectionFromActionMenu.bind(this, 'connected-projects'),
			});
		}
		if (this.props.projectGroup && canUpdateProjects) {
			actionMenuOptions.push({
				text: formatMessage({id: actionMenuOptionTranslationIds.get('group-settings')}),
				cy: 'group-settings',
				onClick: this.navigateToProjectSectionFromActionMenu.bind(this, 'group-settings'),
			});
		}

		const selectedProjectIdString = this.props.project
			? 'P' + this.props.project.companyProjectId
			: 'X' + this.props.projectGroup.companyProjectGroupId;
		const selectedProjectName = this.props.project ? this.props.project.name : this.props.projectGroup.name;

		const navLinkBase = this.props.project
			? constants.projectUrl(this.props.project.companyProjectId)
			: constants.projectGroupUrl(this.props.projectGroup.companyProjectGroupId);

		const sprintsEnabled =
			(this.props.project && this.props.project.sprintTimeBox) ||
			(this.props.projectGroup &&
				this.props.projectGroup.projects &&
				this.props.projectGroup.projects.edges.length > 0 &&
				this.props.projectGroup.projects.edges[0].node.sprintTimeBox);

		const projectBudgetType = this.props.project ? this.props.project.budgetType : null;

		const parentGroup =
			this.props.project && this.props.project.projectGroupId
				? this.props.projectGroups.edges.find(group => group.node.id === this.props.project.projectGroupId)
				: null;

		const projectColor = this.props.project ? this.props.project.projectColor : this.props.projectGroup.color;

		// Should the new Scoping page be used as default? - Remove when switching completely!
		const useNewScopingAsDefault = hasFeatureFlag('task_hierarchy_part2', this.props.viewer.availableFeatureFlags);

		return (
			<div
				className={'project-section-header-v2'}
				style={{backgroundColor: projectColor ? projectColor : undefined, color: textColor}}
			>
				<div className="project-selection">
					<div
						className="project-section-project-select"
						style={{backgroundColor: projectColor ? projectColor : undefined}}
					>
						<NestedDropdown
							useWhiteColor={useWhiteColor}
							useBlackColor={!useWhiteColor}
							placeholder=""
							label=""
							options={projectOptions}
							value={selectedProjectIdString + '  ' + selectedProjectName}
							onChange={this.onProjectChange.bind(this)}
							showArrowWhenCollapsed={true}
							disablePreselectedOptionRemove
							cy="project"
						/>
					</div>
				</div>
				<nav className="section-navigation old">
					<ul>
						{Util.isBaselineProject(this.props.viewer.company.modules, this.props.project) ? (
							<li id="project-navigation-initial-plan" data-cy={'project-header-nav-point-baseline'}>
								<NavLink
									to={`${navLinkBase}/baseline`}
									activeClassName={'active'}
									style={{color: textColor}}
									data-userpilot={'project-navigation-baseline'}
									data-cy={'navigates-to-initial-plan'}
								>
									<span title={formatMessage({id: 'project_section.baseline'})}>
										{formatMessage({id: 'project_section.baseline'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}
						{!this.props.projectGroup && !clientUser ? (
							<li id="project-navigation-scoping" data-cy={'project-header-nav-point-scoping'}>
								<NavLink
									to={`${navLinkBase}/scoping`}
									className="phases"
									activeClassName={'active'}
									style={{color: textColor}}
									data-userpilot={'project-navigation-scoping'}
									data-cy={'navigates-to-scoping'}
								>
									<span title={formatMessage({id: 'project_section.scope'})}>
										{formatMessage({id: 'project_section.scope'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}
						{!this.props.projectGroup &&
						hasFeatureFlag('new_scoping', this.props.viewer.availableFeatureFlags) &&
						!useNewScopingAsDefault &&
						!clientUser ? (
							<li id="project-navigation-new-scoping" data-cy={'project-header-nav-point-scoping-new'}>
								<NavLink
									to={`${navLinkBase}/new-scoping`}
									className="new-phases"
									activeClassName={'active'}
									style={{color: textColor}}
									data-userpilot={'project-navigation-new-scoping'}
									data-cy={'navigates-to-new-scoping'}
								>
									<span title={formatMessage({id: 'project_section.new_scope'})}>
										{formatMessage({id: 'project_section.new_scope'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}
						<li id="project-navigation-workflow" data-cy={'project-header-nav-point-workflow'}>
							<NavLink
								to={`${navLinkBase}/workflow`}
								className="board flow-sample-budget-next"
								activeClassName={'active'}
								style={{color: textColor}}
								data-userpilot={'project-navigation-workflow'}
								data-cy={'navigates-to-workflow'}
							>
								<span title={formatMessage({id: 'workflow.title'})}>
									{formatMessage({id: 'workflow.title'})}
								</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
						{!clientUser && sprintsEnabled ? (
							<li id="project-navigation-sprints" data-cy={'project-header-nav-point-sprints'}>
								<NavLink
									to={`${navLinkBase}/sprints`}
									className="sprints"
									activeClassName={'active'}
									style={{color: textColor}}
									data-userpilot={'project-navigation-sprints'}
									data-cy={'navigates-to-sprints'}
								>
									<span title={formatMessage({id: 'project_section.sprints'})}>
										{formatMessage({id: 'project_section.sprints'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}
						{hasFinancialAccess &&
						!this.props.projectGroup &&
						Util.shouldUseRetainers(this.props.viewer.company.modules) &&
						projectBudgetType === 'RETAINER' ? (
							<li id="project-navigation-periods" data-cy={'project-header-nav-point-periods'}>
								<NavLink
									to={`${navLinkBase}/periods`}
									className="periods"
									activeClassName={'active'}
									style={{color: textColor}}
									data-userpilot={'project-navigation-retainer'}
									data-cy={'navigates-to-periods'}
								>
									<span title={formatMessage({id: 'retainer.periods'})}>
										{' '}
										{formatMessage({id: 'retainer.periods'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}
						{!clientUser ? (
							<li id="project-navigation-timeline" data-cy={'project-header-nav-point-timeline'}>
								<NavLink
									to={`${navLinkBase}/schedule`}
									className="timeline"
									activeClassName={'active'}
									style={{color: textColor}}
									data-userpilot={'project-navigation-timeline'}
								>
									<span title={formatMessage({id: 'project_timeline.title'})}>
										{formatMessage({id: 'project_timeline.title'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}

						{!this.props.projectGroup && hasFinancialAccess ? (
							<li
								id="project-navigation-budget"
								data-cy={'project-header-nav-point-budget'}
								data-userpilot={'project-budget-menu-item'}
							>
								<NavLink
									to={`${navLinkBase}/budget`}
									className="budgetv2 flow-sample-scoping-next"
									activeClassName={'active'}
									style={{color: textColor}}
									data-userpilot={'project-navigation-budget'}
								>
									<span title="Budget">{formatMessage({id: 'common.budget'})}</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}

						{hasFeatureFlag('project_health_page', this.props.viewer.availableFeatureFlags) &&
						!this.props.projectGroup &&
						this.props.project &&
						!this.props.project.projectGroupId &&
						this.props.project.estimationUnit !== ESTIMATION_UNIT.POINTS &&
						Util.AuthorizeViewerAccess('project-health') ? (
							<li
								id="project-navigation-project-health"
								data-cy={'project-header-nav-point-project-health'}
								data-userpilot={'project-health-menu-item'}
							>
								<NavLink
									to={`${navLinkBase}/nova-insights`}
									className="project-health flow-sample-scoping-next"
									activeClassName={'active'}
									style={{color: textColor}}
									data-userpilot={'project-navigation-project-health'}
								>
									<span title={formatMessage({id: 'common.project_health'})}>Nova Insights</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}

						{this.showCurrentLocationForActionMenuOptions(textColor)}
						{actionMenuOptions.length !== 0 ? (
							<ActionsMenu
								horizontalIcon={false}
								disabled={false}
								customColor={projectColor}
								noBorderRadiusStyling={true}
								blackIcon={!useWhiteColor}
								isWhite={useWhiteColor}
								whiteInner={true}
								options={actionMenuOptions}
								showOnRight={true}
								userpilot={'project-navigation-three-dots'}
								cy={'project-navigation'}
							/>
						) : null}
					</ul>
				</nav>
				{parentGroup ? (
					<div className={'connected-project'}>
						<Link to={this.getLinkTo(parentGroup.node.companyProjectGroupId)}>
							<div
								className={'connected-project-indicator'}
								title={'X-' + parentGroup.node.companyProjectGroupId + ' ' + parentGroup.node.name}
							>
								<div
									className={'triangle'}
									style={{borderColor: parentGroup.node.color + ' transparent transparent transparent'}}
								/>
								<div className={'project-id'} style={{color: Util.getTextColorV2(parentGroup.node.color)}}>
									{'X' + parentGroup.node.companyProjectGroupId}
								</div>
							</div>
						</Link>
					</div>
				) : null}
			</div>
		);
	}
}

export default injectIntl(withRouter(ProjectSectionHeader));
